export default __webpack_public_path__ + "static/csirt-bbf4e05f3f7626783692619e9a5f0a0c.webp";